module.exports = __webpack_public_path__ + "static/media/img-goal-11.2cb31402.jpg";